/** Recording acquisition time in the browser's local timezone, as on Recordings. */
export function formatRecordingDate(value: string | number | null | undefined): string {
  if (value == null || value === "") return "Date unknown";
  if (typeof value === "string") {
    // Acquisition time must actually include a time; a date-only string must
    // not acquire an invented midnight from Date.parse.
    const parts=/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?/.exec(value);
    if (!parts) return "Date unknown";
    const [,year,month,day,hour,minute,second="0"]=parts;
    const days=new Date(Date.UTC(Number(year),Number(month),0)).getUTCDate();
    if (Number(month)<1 || Number(month)>12 || Number(day)<1 || Number(day)>days ||
        Number(hour)>23 || Number(minute)>59 || Number(second)>59) return "Date unknown";
  }
  const date = new Date(value);
  return Number.isFinite(date.valueOf()) ? new Intl.DateTimeFormat(undefined, {
    weekday: "short", month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit",
  }).format(date) : "Date unknown";
}
export function formatRecordingDuration(value: number | null | undefined): string {
  if (typeof value !== "number" || !Number.isFinite(value) || value < 0) return "Duration unknown";
  if (value < 60) return `${Math.round(value)}s`;
  if (value < 3600) return `${Math.floor(value / 60)}m`;
  return `${Math.floor(value / 3600)}h ${String(Math.floor(value % 3600 / 60)).padStart(2, "0")}m`;
}
export function recordingLabel(recording: { recording_ref: string; display_date?: string | number | null; duration_seconds?: number | null }): string {
  return `${formatRecordingDate(recording.display_date)} · ${formatRecordingDuration(recording.duration_seconds)} · ${recording.recording_ref}`;
}
